<script lang="ts" setup>
    import { type PropType, computed } from "vue";
    import Media from "@/components/Media.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { type Cta } from "@interfaces/Cta";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    let props = defineProps({
        mediaProps: {
            type: Object as PropType<MediaProps>,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        cta: {
            type: Object as PropType<Cta>,
            required: false
        },
        isSlider: {
            type: Boolean,
            default: false
        }
    });

    const ctaClasses = computed(() => {
        let classes = [props.cta.style ? props.cta.style : "primary"];
        if (props.cta.size != "default") classes.push(props.cta.size);
        return classes;
    });
</script>

<template>
    <div
        :class="
            props.isSlider
                ? `featured_content-column-slider`
                : `featured_content-column`
        "
    >
        <Media
            v-bind="props.mediaProps"
            mediaClasses="featured_content-image"
        />
        <div class="featured_content-text_container">
            <div>
                <h3 role="heading" aria-level="3" class="title-m">{{ props.title }}</h3>
                <p v-html="props.description"></p>
                <RothcoCta
                :ctaType="props.cta.type"
                :class="[...ctaClasses]"
                v-bind="getCtaLink(props.cta)"
                :aria-label="props.cta.aria_label"
            >
                {{ cta.label }}
            </RothcoCta>
            </div>
            
        </div>
    </div>
</template>
